import React from 'react'
import { cn } from '@/lib/utils'

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: string
  size?: number | string
  color?: string
  className?: string
}

// 导入所有SVG图标
const icons = import.meta.glob('./icons/*.svg', {
  eager: true,
  as: 'raw',
})

const Icon: React.FC<IconProps> = ({
  name,
  size = 20,
  color = 'currentColor',
  className,
  ...props
}) => {
  const iconPath = `./icons/${name}Icon.svg`
  const svgContent = icons[iconPath]

  if (!svgContent) {
    console.warn(`Icon "${name}" not found`)
    return null
  }

  // If the file is a full <svg> element, extract its viewBox and strip the wrapper
  const viewBoxMatch = svgContent.match(/viewBox="([^"]+)"/)
  const viewBox = viewBoxMatch ? viewBoxMatch[1] : `0 0 ${size} ${size}`
  const innerContent = /<svg[\s>]/.test(svgContent)
    ? svgContent.replace(/<svg[^>]*>/i, '').replace(/<\/svg>/i, '')
    : svgContent

  return (
    <svg
      width={size}
      height={size}
      color={color}
      className={cn('block', className)}
      viewBox={viewBox}
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      dangerouslySetInnerHTML={{ __html: innerContent }}
      {...props}
    />
  )
}

export default Icon
